module.exports = __webpack_public_path__ + "static/media/27-4.f95a6ee3.mp3";